import { QueryObserverResult, useQuery, UseQueryOptions } from '@tanstack/react-query';
import { RecoilState, RecoilValueReadOnly, useRecoilValue, useSetRecoilState } from 'recoil';

import { API_QUERY_KEYS, GetTeamsRequest, GetTeamsResponse, QueryDefaults } from 'api';
import { getTeams } from '../methods';

export const useGetTeams = (
  requestState: RecoilValueReadOnly<GetTeamsRequest>,
  pageNumberState: RecoilState<number>,
  organisationId?: number,
  options?: UseQueryOptions<GetTeamsResponse>
): QueryObserverResult<GetTeamsResponse> => {
  let request = useRecoilValue(requestState);
  const setPageNumber = useSetRecoilState(pageNumberState);

  if (organisationId) {
    request = { organisationId, ...request };
  }

  return useQuery<GetTeamsResponse>(
    [API_QUERY_KEYS.getTeams, request],
    () => getTeams(request),
    {
      ...QueryDefaults,
      ...options,
      onSuccess: (data: GetTeamsResponse) => {
        if (data?.paginationInfo?.totalCount > 0 && data?.teams.items.length === 0) {
          setPageNumber(1);
        }
      },
      onError: () => {},
    }
  );
};
